import CustomInputFile from './custom-input-file/CustomInputFile.vue';
import pricingApi from '../../../../services/pricing.api';
import jwt from 'jsonwebtoken';
import Modal from '../../../../components/Modal.vue';

export default {
  name: 'UploadModal',
  components: {
    CustomInputFile,
    Modal
  },
  props: {
    isOpen: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      localIsOpen: this.isOpen,
      resetFiles: false,
      fileFieldNames: [
        '01 Tarifa map região',
        '02 Tarifa map veículo',
        '03 Tarifa fator sexo idade',
        '04 Tarifa fator bônus',
        '05 Tarifa fator ano modelo',
        '06 Tarifa fator região',
        '07 Tarifa taxa prêmio franquia',
        '08 Tarifa app',
        '09 Tarifa vidros',
        '10 Coberturas',
        '11 Agravos',
        '12 Tabela de prazo curto',
      ],
      formData: {
        date: '',
        files: Array(11).fill(null),
        zeroKmDiscountPercentage: 0,
      },
      minDateTime: this.getMinDateTime(),
      currentActiveVersion: null,
    };
  },
  computed: {
    isFormValid() {
      return (
        this.formData.date && this.formData.files.every((file) => file !== null)
      );
    },
    isDateValid() {
      return this.formData.date && this.formData.date >= this.minDateTime;
    },
    isZeroKmDiscountPercentageValid() {
      return (
        this.formData.zeroKmDiscountPercentage &&
        this.formData.zeroKmDiscountPercentage >= 0 &&
        this.formData.zeroKmDiscountPercentage <= 100
      );
    },
  },
  watch: {
    isOpen(newVal) {
      this.localIsOpen = newVal;
    },
    localIsOpen(newVal) {
      if (!newVal) {
        this.emitClose();
      } else {
        this.getCurrentActiveVersion();
      }
    },
  },
  methods: {
    getMinDateTime() {
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, '0');
      const day = String(now.getDate()).padStart(2, '0');
      const hours = String(now.getHours()).padStart(2, '0');
      const minutes = String(now.getMinutes()).padStart(2, '0');

      return `${year}-${month}-${day}T${hours}:${minutes}`;
    },
    emitClose() {
      this.$emit('close');
    },
    emitCloseOnSuccess() {
      this.$emit('upload-success');
      this.resetFiles = true;
      this.$nextTick(() => (this.resetFiles = false));
      this.formData.date = '';
      this.formData.files = Array(9).fill(null);
    },
    handleFileChange(file, index) {
      this.$set(this.formData.files, index, file);
    },
    removeFile(index) {
      this.$set(this.formData.files, index, null);
    },
    async handleUpload() {
      const dateTimeNow = this.getMinDateTime();

      if (this.formData.date < dateTimeNow) {
        this.minDateTime = dateTimeNow;
        return;
      }

      const user = jwt.decode(localStorage.getItem('user-token'));

      const payload = {
        user_id: user.id_usuario,
        user_name: user.nome,
        start_date: this.formData.date,
        zero_km_discount_percentage: this.formData.zeroKmDiscountPercentage,
        tb1: this.formData.files[0],
        tb2: this.formData.files[1],
        tb3: this.formData.files[2],
        tb4: this.formData.files[3],
        tb5: this.formData.files[4],
        tb6: this.formData.files[5],
        tb7: this.formData.files[6],
        tb8: this.formData.files[7],
        tb9: this.formData.files[8],
        tb10: this.formData.files[9],
        tb11: this.formData.files[10],
        tb12: this.formData.files[11],
      };

      if (this.currentActiveVersion) {
        payload.replaced_version_id = this.currentActiveVersion.id;
      }

      try {
        this.$vs.loading();
        await pricingApi.uploadPrices(payload);
        this.$vs.notify({
          title: 'Sucesso',
          text: 'Arquivos enviados com sucesso!',
          color: 'success',
          position: 'top-center',
        });
        this.emitCloseOnSuccess();
      } catch (error) {
        this.$vs.notify({
          title: 'Erro',
          text: 'Erro ao enviar precificação',
          color: 'error',
          position: 'top-center',
        });
      } finally {
        this.$vs.loading.close();
      }
    },
    getCurrentActiveVersion() {
      pricingApi.getCurrentActiveVersion().then((data) => {
        this.currentActiveVersion = data;
      });
    },
    formatDateBr(value) {
      const date = new Date(value);
      const options = {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
      };

      return new Intl.DateTimeFormat('pt-BR', options).format(date);
    },
  },
  validateState(ref) {
    if (
      this.veeFields[ref] &&
      (this.veeFields[ref].dirty || this.veeFields[ref].validated)
    ) {
      return !this.veeErrors.has(ref);
    }
    return null;
  },
  validateClass(ref) {
    if (
      this.veeFields[ref] &&
      (this.veeFields[ref].dirty || this.veeFields[ref].validated)
    ) {
      return this.veeErrors.has(ref);
    }
    return null;
  },
};
